import logo from './logo.svg';
import './App.css';
import LessonStagePage from "./features/classResults/pages/LessonStagePage";
import {Route, Routes, useLocation} from "react-router-dom";
import PcVersion from "./features/PcVersion";
import ManagementPage from "./features/classStudentManagement/ManagementPage";
import EmptyPage from "./features/EmptyPage";
import {Toaster} from "react-hot-toast";
import LicensePage from "./features/licenseManagement/LicensePage";
import DateTimeState from "./features/dateTimeState/DateTimeState";
import LoginPage from "./features/auth/LoginCheck";
import LoginCallback from "./features/auth/LoginCallback";
import LoginCheck from "./features/auth/LoginCheck";
import EmptyTopMenu from "./components/EmptyTopMenu";
import TopMenu from "./components/TopMenu";
import HomePage from "./features/home/HomePage";
import {useCurriculumUpdater} from "./components/useCurriculumUpdater";
import ClassLessonPage from "./features/classResults/pages/ClassLessonPage";
import ScrollToTop from "./components/ScrollToTop";
import LogoutCallback from "./features/auth/LogoutCallback";
import ClassHomeworkPage from "./features/classResults/pages/ClassHomeworkPage";
import HomeworkStagePage from "./features/classResults/pages/HomeworkStagePage";
import ClassDailyPage from "./features/classResults/pages/ClassDailyPage";
import DailyStage from "./features/classResults/pages/DailyStagePage";
import HomeHomeworkPage from "./features/home/HomeHomeworkPage";
import ClassAttendancePage from "./features/studentResults/pages/ClassAttendancePage";
import StudentWeeklyResultsPage from "./features/studentResults/pages/StudentWeeklyResultsPage";
import StudentMonthlyResultsPage from "./features/studentResults/pages/StudentMonthlyResultsPage";
import StudentMonthlyReportSharePage from "./features/studentResults/pages/StudentMonthlyReportSharePage";

function App() {
    const location = useLocation();
    const isAuthRoute = location.pathname.includes ("/page");
    const isShareRoute = location.pathname.includes("/share");
    useCurriculumUpdater(); // 커리큘럼 업데이트 체크 실행

  return (
      <div className="App  min-h-full">
          <Toaster position="top-center" reverseOrder={false}/>
          {isAuthRoute && <LoginCheck/>}  {/* auth가 포함되는 경우에만 로그인 확인 */}
          {!isShareRoute && (isAuthRoute ? <TopMenu/> : <EmptyTopMenu/>)}  {/* share 경로가 아닐 때만 TopBar 표시 */}
          <ScrollToTop></ScrollToTop>
          <Routes>
              <Route path="/learning/classes/chapter/lesson/stage" element={<LessonStagePage/>}></Route>
              <Route path="/classLessonStage" element={<LessonStagePage/>}></Route>
              <Route path="/management" element={<ManagementPage/>}></Route>
              {/*<Route path="/license" element={<LicensePage/>}></Route>*/}
              <Route path="/pc-version" element={<PcVersion/>}></Route>
              <Route path="/dateTimeState" element={<DateTimeState/>}></Route>
              <Route path="/classLesson" element={<ClassLessonPage/>}></Route>
              <Route path="/home" element={<HomePage/>}></Route>
              <Route path="/oAuthLogin" element={<LoginCallback/>}></Route>
              <Route path="/oAuthLogout" element={<LogoutCallback/>}></Route>
              <Route path="/classAttendance" element={<ClassAttendancePage/>}></Route>
              <Route path="/studentWeeklyResults" element={<StudentWeeklyResultsPage/>}></Route>
              <Route path="/studentMonthlyResults" element={<StudentMonthlyResultsPage/>}></Route>
              <Route path="/share/studentMonthlyReport" element={<StudentMonthlyReportSharePage/>}></Route>
              {/*하위 경로에 auth가 있을경우 로그인이 필요한 페이지*/}
              <Route path="/page/management" element={<ManagementPage/>}></Route>
              <Route path="/page/license" element={<LicensePage/>}></Route>
              <Route path="/page/home" element={<HomePage/>}></Route>
              <Route path="/page/homeHomework" element={<HomeHomeworkPage/>}></Route>
              <Route path="/page/learning/classes/chapter/lesson/stage" element={<LessonStagePage/>}></Route>
              <Route path="/page/classLesson" element={<ClassLessonPage/>}></Route>
              <Route path="/page/classLessonStage" element={<LessonStagePage/>}></Route>
              <Route path="/page/classHomework" element={<ClassHomeworkPage/>}></Route>
              <Route path="/page/classHomeworkStage" element={<HomeworkStagePage/>}></Route>
              <Route path="/page/classDaily" element={<ClassDailyPage/>}></Route>
              <Route path="/page/classDailyStage" element={<DailyStage/>}></Route>
              <Route path="/page/classAttendance" element={<ClassAttendancePage/>}></Route>
              <Route path="/page/studentWeeklyResults" element={<StudentWeeklyResultsPage/>}></Route>
              <Route path="/page/studentMonthlyResults" element={<StudentMonthlyResultsPage/>}></Route>

              {/* 상단에 위치하는 라우트들의 규칙을 모두 확인하고, 일치하는 라우트가 없다면 마지막 라우트가 화면에 나타나게 됨. */}
              {isAuthRoute ? <Route path="*" element={<HomePage/>}></Route>: <Route path="*" element={<EmptyPage/>}></Route>}
          </Routes>
      </div>
  );
}

export default App;
